<template>
  <div
    :class="[
      'card rounded-none border border-customer-card initial:overflow-hidden initial:bg-white',
      {
        group: is !== 'div' && !disabled,
      },
    ]"
  >
    <slot name="header" />
    <m-dot-loader v-if="loading" class="py-16" />
    <component
      :is="is"
      v-else
      :role="$attrs.role"
      :aria-checked="$attrs['aria-checked']"
      :aria-label="$attrs['aria-label']"
      :class="[
        'card-body w-full gap-0 p-0',
        {
          'link no-underline': is === 'router-link' || is === 'a',
        },
      ]"
      :to="to"
      :href="$attrs.href"
      :target="$attrs.target"
      @click="is === 'div' ? undefined : $emit('click')"
    >
      <div v-if="$slots.title" class="card-title w-full">
        <slot name="title" />
      </div>
      <slot />
      <m-action-list v-if="$slots.actions" :column="actionList?.column" :position="actionList?.position" class="pt-3">
        <slot name="actions"></slot>
      </m-action-list>
      <slot name="inner-footer" />
    </component>
    <slot name="footer" />
  </div>
</template>

<script lang="ts" setup>
  import type { MRouterLinkProps } from '@core/components/MLink';
  import MDotLoader from '@core/components/MDotLoader/MDotLoader.vue';
  import type { MActionListProps } from '@core/components/MActionList/MActionList.vue';
  import MActionList from '@core/components/MActionList/MActionList.vue';

  export interface Emits {
    (e: 'click'): void;
  }
  export interface MCardProps {
    /**
     * Actionable card.
     */
    is?: 'div' | 'button' | 'router-link' | 'a';
    to?: MRouterLinkProps['to'];
    /**
     * Whether or not to show the loading indicator
     * Hides Content untile loading is complete
     */
    loading?: boolean;
    actionList?: MActionListProps;
    disabled?: boolean;
  }
  defineSlots<{
    default?: () => any;
    title?: () => any;
    actions?: () => any;
    header?: () => any;
    /**
     * Footer is a footer that is outside the card body, will not active click events
     */
    footer?: () => any;
    /**
     * Inner footer is a footer that is inside the card body
     */
    'inner-footer'?: () => any;
  }>();

  defineEmits<Emits>();
  withDefaults(defineProps<MCardProps>(), {
    compact: false,
    button: false,
    to: undefined,
    is: 'div',
    actionList: undefined,
    disabled: false,
  });
</script>
